import Model from '@/models/Model'

export default class ParagraphVisualModel extends Model {
  constructor (data, included = null) {
    super(data, included)
  }

  get originalImg () {
    return this.get('rel.visual.rel.field_image.attributes.url')
  }

  get derivatives () {
    return this.get('rel.visual.rel.field_image.links')
  }

  get largeImg () {
    return this.get('rel.visual.rel.thumbnail.attributes.url') || this.originalImg()
  }

  get title () {
    return this.get('attributes.title') || this.get('rel.visual.attributes.name') || null
  }
}
